function ComponentItem(obj, action) {
  if (typeof obj !== "object") return

  this.action = action
  if (action !== "NEW") this.INTERNAL_BOM_DETAIL_NUM = obj.internal_bom_detail_num

  this.item = obj.item
  this.qty_needed_per_item = parseInt(obj.qty_needed_per_item, 10)

  if (action !== "CHANGE") {
    this.build_sequence = obj.build_sequence
    this.quantity_um = "EA"
    this.build_level = 1
    this.item_class = "eStore"
    this.inc_qty_eligible = "N"
    this.company = obj.company
  }

  this.user_stamp = obj.user_stamp
  this.date_time_stamp = new Date()
}

export default ComponentItem
